import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SelfStatsSkinMood = ({ skinStats, startDate, endDate }) => {
  const { t } = useTranslation();
  const getDatesInRange = (start, end) => {
    const dates = [];
    let cur = new Date(start);
    while (cur <= end) {
      dates.push(cur.toISOString().split("T")[0]);
      cur.setDate(cur.getDate() + 1);
    }
    return dates;
  };

  const xAxisCategories = useMemo(() => getDatesInRange(startDate, endDate), [startDate, endDate]);

  const buildSeries = (qId) =>
    xAxisCategories.map((date) => {
      const match = skinStats.find(
        (s) => s.createdTime && s.createdTime.startsWith(date) && String(s.questionId) === String(qId)
      );
      return match ? parseInt(match.answer, 10) : null;
    });

  const options = {
    chart: { type: "line", height: 280, margin: [10, 0, 50, 50], backgroundColor: "rgba(0,0,0,0)" },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories: xAxisCategories,
      title: { text: t("selfStats.daysAxis") },
      lineWidth: 0,
      labels: {
        style: { fontSize: "11px" },
        formatter() {
          return Highcharts.dateFormat("%b %d", new Date(this.value));
        },
      },
    },
    yAxis: { title: { text: t("selfStats.intensityAxis") }, gridLineDashStyle: "dot", gridLineColor: "#646464" },
    plotOptions: { line: { dataLabels: { enabled: true }, enableMouseTracking: false } },
    series: [
      { name: t("skinMoodEntry.label.sleeplessness"), data: buildSeries(4), color: "#4098e3" },
      { name: t("skinMoodEntry.label.itchiness"), data: buildSeries(1), color: "#a2d8ff" },
      { name: t("skinMoodEntry.label.redness"), data: buildSeries(3), color: "#e67d1b" },
      { name: t("skinMoodEntry.label.pain"), data: buildSeries(2), color: "#f3d53a" },
    ],
    legend: { enabled: false },
  };

  return (
    <div className="selfstats-box">
      <h2 className="selfstats-title">{t("skinMoodEntry.chartTitle")}</h2>
      <HighchartsReact highcharts={Highcharts} options={options} />
      <ul className="selfstats-legend">
        <li><span className="dot" style={{ background: "#4098e3" }}></span> {t("skinMoodEntry.label.sleeplessness")}</li>
        <li><span className="dot" style={{ background: "#a2d8ff" }}></span> {t("skinMoodEntry.label.itchiness")}</li>
        <li><span className="dot" style={{ background: "#e67d1b" }}></span> {t("skinMoodEntry.label.redness")}</li>
        <li><span className="dot" style={{ background: "#f3d53a" }}></span> {t("skinMoodEntry.label.pain")}</li>
      </ul>
    </div>
  );
};

SelfStatsSkinMood.defaultProps = { skinStats: [], startDate: new Date(), endDate: new Date() };

export default SelfStatsSkinMood;
